import { t } from "i18next";
import { NavLink } from "react-router-dom";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../ui/Separator";

type Props = {}

const Tracking = ({}: Props) => {

  return (
    <div className="w-full h-full flex flex-col bg-background">
      <div className="flex-none h-12 w-full flex items-center">
        <div className="flex items-center w-[300px] px-4">
          <NavLink
            className="flex-none text-base font-semibold cursor-pointer"
            to="/"
          >
            {t("tracking")}
          </NavLink>
        </div>
        <Separator orientation="vertical"/>
      </div>
      <Separator className="flex-none"/>
      <div className="flex w-full h-full">
        <div className="flex flex-col h-full w-[300px]">
          <ScrollArea>
            Список оборудования
          </ScrollArea>
        </div>
        <Separator className="flex-none" orientation="vertical"/>
        <ScrollArea>
          Карта
        </ScrollArea>
      </div>
      
    </div>
  );
};

export default Tracking;
